/**
 * The five chart types, with the toolbar icons that switch between them.
 *
 * Each icon draws the mark it stands for rather than a generic glyph, so the
 * toolbar reads as a row of thumbnails.
 */

import { __ } from '@wordpress/i18n';

const Bars = (
	<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
		<rect x="3" y="12" width="4" height="9" rx="1" />
		<rect x="10" y="7" width="4" height="14" rx="1" />
		<rect x="17" y="3" width="4" height="18" rx="1" />
	</svg>
);

const Line = (
	<svg
		viewBox="0 0 24 24"
		width="24"
		height="24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
	>
		<path d="M3 17l5-6 4 3 4-7 5 4" />
	</svg>
);

const Area = (
	<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
		<path
			d="M3 17l5-6 4 3 4-7 5 4v10H3z"
			fillOpacity="0.25"
			stroke="none"
		/>
		<path
			d="M3 17l5-6 4 3 4-7 5 4"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const Pie = (
	<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
		<path d="M12 3a9 9 0 1 0 9 9h-9V3z" fillOpacity="0.3" />
		<path d="M12 3a9 9 0 0 1 9 9h-9V3z" />
	</svg>
);

const Donut = (
	<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
		<path
			d="M12 3a9 9 0 1 0 9 9h-4.5a4.5 4.5 0 1 1-4.5-4.5V3z"
			fillOpacity="0.3"
		/>
		<path d="M12 3a9 9 0 0 1 9 9h-4.5A4.5 4.5 0 0 0 12 7.5V3z" />
	</svg>
);

export const CHART_TYPE_OPTIONS = [
	{ value: 'bar', label: __( 'Bar', 'brandy-blocks' ), icon: Bars },
	{ value: 'line', label: __( 'Line', 'brandy-blocks' ), icon: Line },
	{ value: 'area', label: __( 'Area', 'brandy-blocks' ), icon: Area },
	{ value: 'pie', label: __( 'Pie', 'brandy-blocks' ), icon: Pie },
	{ value: 'donut', label: __( 'Donut', 'brandy-blocks' ), icon: Donut },
];
